import store from '@/store/index.js'
import { makeRequest } from '@/libs/RequestModule'

const loadFoodRestriction = async function () {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    const foodRestriction = (await makeRequest('getFoodRestriction', { CDCONSUMIDOR }))?.data
    store.dispatch('setFoodRestrictions', foodRestriction)
}

const updateFoodRestriction = async function (QTCONSDIARAL, IDPAI, CDPRODUTO, cdWeekDays) {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    const updatedFoodRestriction = (await makeRequest('updateFoodRestriction', { CDCONSUMIDOR, QTCONSDIARAL, IDPAI, CDPRODUTO, cdWeekDays }))?.data
    return updatedFoodRestriction
}

const getConsumerFamilies = async function () {
    const consumerFamilies = (await makeRequest('getConsumerFamilies'))?.data
    store.dispatch('setConsumerFamilies', consumerFamilies)
}

const getFamilyProducts = async function (CDFAMILISALD) {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    const familyProducts = (await makeRequest('getFamilyProducts', { CDCONSUMIDOR, CDFAMILISALD }))?.data
    store.dispatch('setFamilyProducts', familyProducts)
}

const addFoodRestriction = async function (productCodes, CDFAMILISALD, QTCONSDIARAL, cdWeekDays) {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    const newFoodRestriction = (await makeRequest('addFoodRestriction', { CDCONSUMIDOR, productCodes, CDFAMILISALD, QTCONSDIARAL, cdWeekDays }))?.data
    return newFoodRestriction
}

const deleteFoodRestriction = async function (CDFAMILISALD, CDPRODUTO) {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    const deletedFoodRestriction = (await makeRequest('deleteFoodRestriction', { CDCONSUMIDOR, CDFAMILISALD, CDPRODUTO }))?.data
    return deletedFoodRestriction
}

export { loadFoodRestriction, updateFoodRestriction, getConsumerFamilies, getFamilyProducts, addFoodRestriction, deleteFoodRestriction }
